import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { default_catalog_filters, default_filters } from '../services';
import {
  CatalogView,
  Characteristic,
  ProductFile,
  Products,
  ProductsFilters,
  AddProductDialog,
  CategoriesSlug,
  SoftwareTypesInterface,
  LicenseKeys, CatalogRequestFilters,
} from '../types';

export default class CatalogState extends BaseState {
  products: Products.Product[] = [];

  catalog_products: Products.CatalogProductItem[] = [];

  current_select_keys: string[] = [];

  search_key = '';

  current_product: Products.Product | null = {} as Products.Product;

  related_prods: Products.Product[] = [];

  filters: ProductsFilters = default_filters();

  catalog_filters: CatalogRequestFilters = default_catalog_filters();

  catalog_view: CatalogView = CatalogView.TABLE;

  files: ProductFile[] = [];

  characteristics: Characteristic[] = [];

  add_product_dialog: AddProductDialog = {
    visible: false,
    title: 'Добавление товаров в корзину',
    type: '',
  };

  license_key = '';
  license_key_arr: LicenseKeys[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['product_code'],
    sortDesc: [true],
  };

  categories: CategoriesSlug[] = [];

  catalog_categories: Products.CategoryFilterItem[] = [];
  catalog_software_types: Products.CatalogFilterItem[] = [];
  catalog_equipment_models: Products.EquipmentModelFilterItem[] = [];
  has_realization_contract?: boolean = undefined;

  models: number[] = []

  software_types: SoftwareTypesInterface[] = []

  prices_types: { requested: boolean, items: string[] } = {
    requested: false,
    items: [],
  };

  zip_cat_filter: number[] = [];

  query_categories: number[] = [];

  is_fixed = false;

  is_show_all_price = false;

  is_favorites_only_toggle = false;

  loading = false;

  is_new_catalog = false;
}
